import apiRequest from "./apiRequest";

export const addToCart = async (data, query, token) => {
  const response = await apiRequest.post(`/v2/cart/add?${query}`, data, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const removeToCart = async (id, token) => {
  const response = await apiRequest.delete(`/v2/cart/${id}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const fetchCartItems = async (token) => {
  const response = await apiRequest.get("v2/cart/", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const removeAllItemsToCart = async (token) => {
  const response = await apiRequest.delete("/v2/cart/", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const checkoutCartItems = async (query, token) => {
  const response = await apiRequest.post(`/v2/cart/checkout?${query}`, "", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const fetchStackBasePrice = async (token) => {
  const response = await apiRequest.get("v2/stack/price", {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};
